import { render, staticRenderFns } from "./ImportDevolucionReview.vue?vue&type=template&id=7c93ed14&scoped=true"
import script from "./ImportDevolucionReview.vue?vue&type=script&lang=js"
export * from "./ImportDevolucionReview.vue?vue&type=script&lang=js"
import style0 from "./ImportDevolucionReview.vue?vue&type=style&index=0&id=7c93ed14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c93ed14",
  null
  
)

export default component.exports